export type TallyTone = 'coral' | 'teal' | 'amber' | 'lime'

export interface TallyProps {
  label: string
  value: string | number
  tone?: TallyTone
}

const TONES: Record<TallyTone, string> = {
  coral: 'bg-coral-soft text-coral',
  teal: 'bg-teal-soft text-teal',
  amber: 'bg-amber-soft text-amber',
  lime: 'bg-lime-soft text-lime',
}

/**
 * A labelled number.
 *
 * Called a score badge once, which it is not: there are no scores here. It
 * counts things that happened — games played, words solved — rather than
 * rating them.
 */
export function Tally({ label, value, tone = 'teal' }: TallyProps) {
  return (
    <span
      className={`inline-flex flex-col items-center rounded-(--radius-control) px-4 py-2 ${TONES[tone]}`}
    >
      <span className="font-display text-(length:--text-heading) leading-none font-semibold">
        {value}
      </span>
      <span className="text-(length:--text-small) opacity-80">{label}</span>
    </span>
  )
}
